var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.718,
    height: 89.718,
    viewBox: "0 0 89.718 89.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_viviendas",
    transform: "translate(-306 -896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 89.718,
    height: 89.718,
    transform: "translate(306 896)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8286",
    "data-name": "Group 8286",
    transform: "translate(229.718 889.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19966",
    "data-name": "Path 19966",
    d: "M257.463,101.327a15.947,15.947,0,1,0-15.947,15.944A15.963,15.963,0,0,0,257.463,101.327Zm-27.406,0a11.461,11.461,0,1,1,11.461,11.458A11.474,11.474,0,0,1,230.057,101.327Z",
    transform: "translate(-120.375 -59.181)",
    fill: "#0595f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19967",
    "data-name": "Path 19967",
    d: "M89.743,84.782h62.8a2.243,2.243,0,0,0,0-4.485H126.4c6.54-7.195,19.389-23.232,19.389-38.151a24.646,24.646,0,0,0-49.292,0c0,14.919,12.85,30.955,19.389,38.151H89.743a2.243,2.243,0,0,0,0,4.485Zm31.4-62.8a20.182,20.182,0,0,1,20.16,20.16c0,14.85-15.185,31.981-20.16,37.194-4.975-5.212-20.16-22.344-20.16-37.194A20.182,20.182,0,0,1,121.141,21.985Z",
    fill: "#0595f0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocation);
export default __webpack_public_path__ + "static/media/ico_location.b523183cd923e3a1e911a5ece9a57a50.svg";
export { ForwardRef as ReactComponent };